module.exports = __webpack_public_path__ + "static/media/email.e3cc4a27.svg";